import { ModalType } from '~/types/modal-types';
import {
  SET_LOADING_DATA,
  SET_LOADING_PRODUCT_DATA,
  SET_LOADING_SEND,
  SET_SHOW_MODAL_ORDER,
  UPDATE_MODAL_ORDER,
  INITIALIZE_SUCCESS,
  INITIALIZE_REQUEST,
  UPDATE_ORDER,
  UPDATE_SELECTS,
  SET_CLIENT_REQUEST,
  SET_CLIENT_SUCCESS,
  SET_ORDER_TYPE_SUCCESS,
  SET_ORDER_TYPE_REQUEST,
  SET_SHIPPING_TYPE_SUCCESS,
  SET_SHIPPING_TYPE_REQUEST,
  SET_SHIPPING_FEE_REQUEST,
  GET_SHIPPING_REQUEST,
  GET_SHIPPING_SUCCESS,
  SET_SUBSIDIARY_REQUEST,
  SET_SUBSIDIARY_SUCCESS,
  SET_SUBSIDIARY_STOCK_REQUEST,
  SET_SUBSIDIARY_STOCK_SUCCESS,
  SET_PAYMENT_OPTION_REQUEST,
  SET_PAYMENT_OPTION_SUCCESS,
  SET_PAYMENT_PLAN_REQUEST,
  SET_PAYMENT_PLAN_SUCCESS,
  SET_PAYMENT_PLAN_GROUP_REQUEST,
  SET_PAYMENT_PLAN_GROUP_SUCCESS,
  SET_PAYMENT_PLAN_GROUP_ETHICAL,
  SET_PAYMENT_PLAN_GROUP_GENERIC,
  SET_LOAD_TYPE_REQUEST,
  SET_LOAD_TYPE_SUCCESS,
  SET_SHOW_MODAL_PRODUCT_DETAIL,
  SET_HIDE_CART_RECOMMENDATIONS,
  SET_SHOW_MODAL_PRODUCT_REQUEST,
  SET_SHOW_MODAL_PRODUCT_VARIANT,
  ADD_PRODUCT_CART_REQUEST,
  ADD_PRODUCT_CART_SUCCESS,
  UPDATE_QUANTITY_REQUEST,
  UPDATE_QUANTITY_SUCCESS,
  CHECK_QUANTITY_MULTIPLE,
  UPDATE_SOLDPRICE_REQUEST,
  SET_BONIFICATED_REQUEST,
  UPDATE_DISCOUNT_REQUEST,
  SET_PRODUCT_PACKING,
  SET_PRODUCT_PROMOTION,
  REMOVE_PRODUCT_CART_REQUEST,
  REMOVE_PRODUCT_CART_SUCCESS,
  CLEAR_ALL_CART,
  CLEAR_ORDER_ITEM,
  LOAD_PRODUCT_REQUEST,
  LOAD_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  VALIDATE_ORDER_REQUEST,
  VALIDATE_ORDER_SUCCESS,
  SET_SEND_PDF_INFO,
  SET_DELIVERY_ADDRESS_CODE,
  SET_ESTIMATED_DELIVERY_DATE,
  SET_ORDER_NUMBER,
  SET_SOME_OBSERVATION,
  SET_DEFAULT_DELIVERY,
  SET_BUDGET,
  SEND_ORDER,
  SET_VARIABLE_PAYMENT_REQUEST,
  SET_VARIABLE_PAYMENT_SUCCESS,
  STORE_PERCENTUAL_RATE,
  STORE_ORDER_INFOS,
  SET_ORDER_TYPE_BONIFICATED_REQUEST,
  SET_SHOW_MODAL_REASON,
  VALIDATE_PASSWORD_MODAL_REASON,
  SET_BILLING_DATE,
  UPDATE_QUANTITY_TOTAL_UNIT_REQUEST,
  SET_SHOW_MODAL_PRODUCT_PROMOTION_KIT,
  GET_PRODUCT_PROMOTION_KIT_REQUEST,
  ADD_PROMOTION_KIT_REQUEST,
  GET_PROMOTION_KIT_LIST_SUCESS,
  UPDATE_PROMOTION_KIT_REQUEST,
  SET_BONIFICATION_BOUND,
  SET_OPEN_MODAL_BONIFICATION,
  SET_ORDER_BONIFICATION_REQUEST,
  SET_ORDER_BONIFICATION_SUCCESS,
  SET_PRODUCT_COMPLEMENT,
  UPDATE_ORDER_MARGIN,
  GET_ALTERNATIVE_PRODUCT_REQUEST,
  GET_ALTERNATIVE_PRODUCT_SUCCESS,
  SPLIT_ORDER_VALIDATION_REQUEST,
  SPLIT_ORDER_VALIDATION_SUCCESS,
  SET_SHIPPING_DELIVERY_PROVIDER,
  SET_VENDOR,
  SET_ASSISTED_SALE_TYPE,
  APPLY_DISCOUNT_TO_ALL_ITEMS_REQUEST,
  APPLY_DISCOUNT_TO_ALL_ITEMS_SUCCESS,
  CALCULATE_BALANCE_REQUEST,
  UPDATE_BALANCE_SUCCESS,
  GET_RESTRICTIONS_REQUEST,
  CLEAR_ORDER,
  SET_SUBSIDIARY_PRODUCT_STOCK_SUCCESS,
  SET_SUBSIDIARY_PRODUCT_STOCK_REQUEST,
  SET_SUBSIDIARY_STOCK_RESTRICTIONS,
  SET_SUBSIDIARY_STOCK_RESTRICTIONS_REQUEST,
  UPDATE_ORDER_OTHER_EXPENSES,
  UPDATE_UNITARY_VALUE_REQUEST,
  SET_BONIFICATION_TYPE_REQUEST
} from './order-constants';
import { OrderCreateInterface, ProductModalProps, SubsidiaryStockRestrictions } from './order-interface';
import { GET_PROMOTION_KIT_LIST_REQUEST } from './order-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingProductData = (loading: Boolean) => {
  return {
    type: SET_LOADING_PRODUCT_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setShowModalOrder = (show: Boolean) => {
  return {
    type: SET_SHOW_MODAL_ORDER,
    show
  };
};

export const updateModal = payload => {
  return {
    type: UPDATE_MODAL_ORDER,
    payload
  };
};

export const initializeRequest = (payload?: {
  id: string;
  copy?: boolean;
  budget?: boolean;
  bonification?: boolean;
  searchParams?: string;
  complementary?: boolean;
  clientIdToKeep?: string;
}) => {
  return {
    type: INITIALIZE_REQUEST,
    payload
  };
};

export const initializeSuccess = payload => {
  return {
    type: INITIALIZE_SUCCESS,
    payload
  };
};

export const updateOrder = (payload: OrderCreateInterface) => {
  return {
    type: UPDATE_ORDER,
    payload
  };
};

export const updateSelects = payload => {
  return {
    type: UPDATE_SELECTS,
    payload
  };
};

export const setClientRequest = _id => {
  return {
    type: SET_CLIENT_REQUEST,
    _id
  };
};

export const setClientSuccess = payload => {
  return {
    type: SET_CLIENT_SUCCESS,
    payload
  };
};

export const setShowModalReason = payload => {
  return {
    type: SET_SHOW_MODAL_REASON,
    payload
  };
};

export const setValidatePasswordModalReason = (payload: string) => {
  return {
    type: VALIDATE_PASSWORD_MODAL_REASON,
    payload
  };
};

export const setOrderTypeRequest = id => {
  return {
    type: SET_ORDER_TYPE_REQUEST,
    id
  };
};

export const setOpenModalBonification = payload => {
  return {
    type: SET_OPEN_MODAL_BONIFICATION,
    payload
  };
};

export const setOrderBonificationRequest = payload => {
  return {
    type: SET_ORDER_BONIFICATION_REQUEST,
    payload
  };
};

export const setOrderBonificationSuccess = payload => {
  return {
    type: SET_ORDER_BONIFICATION_SUCCESS,
    payload
  };
};

export const setOrderTypeSuccess = payload => {
  return {
    type: SET_ORDER_TYPE_SUCCESS,
    payload
  };
};

export const setShippingTypeRequest = shippingType => {
  return {
    type: SET_SHIPPING_TYPE_REQUEST,
    shippingType
  };
};

export const setShippingTypeSuccess = payload => {
  return {
    type: SET_SHIPPING_TYPE_SUCCESS,
    payload
  };
};

export const getShippingRequest = () => {
  return {
    type: GET_SHIPPING_REQUEST
  };
};

export const getShippingSuccess = (payload: any, precision?: number) => {
  return {
    type: GET_SHIPPING_SUCCESS,
    payload,
    precision
  };
};

export const setSubsidiaryRequest = subsidiary => {
  return {
    type: SET_SUBSIDIARY_REQUEST,
    subsidiary
  };
};

export const setSubsidiarySuccess = payload => {
  return {
    type: SET_SUBSIDIARY_SUCCESS,
    payload
  };
};

export const setSubsidiaryStockRequest = subsidiaryStock => {
  return {
    type: SET_SUBSIDIARY_STOCK_REQUEST,
    subsidiaryStock
  };
};

export const setSubsidiaryStockSuccess = payload => {
  return {
    type: SET_SUBSIDIARY_STOCK_SUCCESS,
    payload
  };
};

export const setPaymentOptionRequest = paymentOption => {
  return {
    type: SET_PAYMENT_OPTION_REQUEST,
    paymentOption
  };
};

export const setPaymentOptionSuccess = payload => {
  return {
    type: SET_PAYMENT_OPTION_SUCCESS,
    payload
  };
};

export const setPaymentPlanRequest = paymentPlan => {
  return {
    type: SET_PAYMENT_PLAN_REQUEST,
    paymentPlan
  };
};

export const setPaymentPlanSuccess = payload => {
  return {
    type: SET_PAYMENT_PLAN_SUCCESS,
    payload
  };
};

export const setPaymentPlanGroupRequest = (key, paymentPlan) => {
  return {
    type: SET_PAYMENT_PLAN_GROUP_REQUEST,
    key,
    paymentPlan
  };
};

export const setPaymentPlanGroupSuccess = payload => {
  return {
    type: SET_PAYMENT_PLAN_GROUP_SUCCESS,
    payload
  };
};

export const setLoadTypeRequest = loadType => {
  return {
    type: SET_LOAD_TYPE_REQUEST,
    loadType
  };
};

export const setBonificationTypeRequest = payload => {
  return {
    type: SET_BONIFICATION_TYPE_REQUEST,
    payload
  };
};

export const setLoadTypeSuccess = payload => {
  return {
    type: SET_LOAD_TYPE_SUCCESS,
    payload
  };
};

export const setVariablePaymentRequest = payload => {
  return {
    type: SET_VARIABLE_PAYMENT_REQUEST,
    payload
  };
};

export const setVariablePaymentSuccess = payload => {
  return {
    type: SET_VARIABLE_PAYMENT_SUCCESS,
    payload
  };
};

export const storePercentualRate = percentualRate => ({
  percentualRate,
  type: STORE_PERCENTUAL_RATE
});

export const storeOrderInfos = orderDetails => ({
  orderDetails,
  type: STORE_ORDER_INFOS
});

export const setShowModalProductDetail = (payload: ModalType<ProductModalProps>) => {
  return {
    type: SET_SHOW_MODAL_PRODUCT_DETAIL,
    payload
  };
};

export const setHideCartRecommendations = (payload: boolean) => ({
  type: SET_HIDE_CART_RECOMMENDATIONS,
  payload
});

export const setShowModalProductRequest = (payload: ModalType<ProductModalProps>) => {
  return {
    type: SET_SHOW_MODAL_PRODUCT_REQUEST,
    payload
  };
};

export const setShowModalProductVariant = (payload: ModalType<ProductModalProps>) => {
  return {
    type: SET_SHOW_MODAL_PRODUCT_VARIANT,
    payload
  };
};

export function addProductRequest(orderItem) {
  return {
    type: ADD_PRODUCT_CART_REQUEST,
    orderItem
  };
}

export function addProductSuccess(payload) {
  return {
    type: ADD_PRODUCT_CART_SUCCESS,
    payload
  };
}

export function loadProductRequest(payload, setInCart = false) {
  return {
    type: LOAD_PRODUCT_REQUEST,
    payload,
    setInCart
  };
}

export function loadProductSuccess(payload) {
  return {
    type: LOAD_PRODUCT_SUCCESS,
    payload
  };
}

export function updateProductRequest(payload, closeModal = true) {
  return {
    type: UPDATE_PRODUCT_REQUEST,
    payload,
    closeModal
  };
}

export function updateProductSuccess(payload, tenantID, precision) {
  return {
    type: UPDATE_PRODUCT_SUCCESS,
    payload,
    precision,
    tenantID
  };
}

export function removeProductRequest(payload) {
  return {
    type: REMOVE_PRODUCT_CART_REQUEST,
    payload
  };
}

export function removeProductSuccess(productId, productGrade, tenantID, configuration) {
  return {
    type: REMOVE_PRODUCT_CART_SUCCESS,
    productId,
    productGrade,
    tenantID,
    configuration
  };
}

export function clearAllCart() {
  return {
    type: CLEAR_ALL_CART
  };
}

export function clearOrderItem() {
  return {
    type: CLEAR_ORDER_ITEM
  };
}

export function clearOrder() {
  return {
    type: CLEAR_ORDER
  };
}

export function updateQuantityRequest(payload, id?: string) {
  return {
    type: UPDATE_QUANTITY_REQUEST,
    id,
    payload
  };
}

export function updateQuantitySuccess(payload) {
  return {
    type: UPDATE_QUANTITY_SUCCESS,
    payload
  };
}

export function setProductComplementRequest(payload: string) {
  return {
    type: SET_PRODUCT_COMPLEMENT,
    payload
  };
}

export function updateTotalUnityRequest(payload) {
  return {
    type: UPDATE_QUANTITY_TOTAL_UNIT_REQUEST,
    payload
  };
}

export function checkQuantityMutiple() {
  return {
    type: CHECK_QUANTITY_MULTIPLE
  };
}

export function updateSoldPriceRequest(payload) {
  return {
    type: UPDATE_SOLDPRICE_REQUEST,
    payload
  };
}

export function updateUnitaryValueRequest(payload) {
  return {
    type: UPDATE_UNITARY_VALUE_REQUEST,
    payload
  };
}

export function updateDiscountRequest(payload, id?: string) {
  return {
    type: UPDATE_DISCOUNT_REQUEST,
    payload,
    id
  };
}

export function setPacking(payload) {
  return {
    type: SET_PRODUCT_PACKING,
    payload
  };
}

export function setPromotion(payload, quantity = null) {
  return {
    type: SET_PRODUCT_PROMOTION,
    payload,
    quantity
  };
}

export function setShowModalPromotionKitListRequest(payload?: any) {
  return {
    type: GET_PROMOTION_KIT_LIST_REQUEST,
    payload
  };
}

export function setShowModalPromotionKitListSuccess(payload) {
  return {
    type: GET_PROMOTION_KIT_LIST_SUCESS,
    payload
  };
}

export function setShowModalPromotionKit(payload) {
  return {
    type: SET_SHOW_MODAL_PRODUCT_PROMOTION_KIT,
    payload
  };
}

export function getPromotionKit({ payload, show }: { payload: any; show: boolean }) {
  return {
    type: GET_PRODUCT_PROMOTION_KIT_REQUEST,
    payload,
    show
  };
}

export function addPromotionKit(payload: any) {
  return {
    type: ADD_PROMOTION_KIT_REQUEST,
    payload
  };
}

export function updatePromotionKit(payload: any) {
  return {
    type: UPDATE_PROMOTION_KIT_REQUEST,
    payload
  };
}

export function setBonificated(payload) {
  return {
    type: SET_BONIFICATED_REQUEST,
    payload
  };
}

export function setOrderTypeBonificated(payload) {
  return {
    type: SET_ORDER_TYPE_BONIFICATED_REQUEST,
    payload
  };
}

export const setPaymentPlanGroupEthical = payload => {
  return {
    type: SET_PAYMENT_PLAN_GROUP_ETHICAL,
    payload
  };
};

export const setPaymentPlanGroupGeneric = payload => {
  return {
    type: SET_PAYMENT_PLAN_GROUP_GENERIC,
    payload
  };
};

export const validateOrderRequest = () => {
  return {
    type: VALIDATE_ORDER_REQUEST
  };
};

export const validateOrderSuccess = (payload: any) => {
  return {
    type: VALIDATE_ORDER_SUCCESS,
    payload
  };
};

export const setSendPDFInfo = (payload: any) => {
  return {
    type: SET_SEND_PDF_INFO,
    payload
  };
};

export const setBonificationBound = (payload: any) => {
  return {
    type: SET_BONIFICATION_BOUND,
    payload
  };
};

export const setDeliveryAddressCode = (payload: any) => {
  return {
    type: SET_DELIVERY_ADDRESS_CODE,
    payload
  };
};

export const setBillingDate = (payload?: any) => {
  return {
    type: SET_BILLING_DATE,
    payload
  };
};

export const setEstimatedDate = (payload: any) => {
  return {
    type: SET_ESTIMATED_DELIVERY_DATE,
    payload
  };
};

export const setOrderNumber = (payload: any) => {
  return {
    type: SET_ORDER_NUMBER,
    payload
  };
};

export const setSomeObsevation = (payload: any) => {
  return {
    type: SET_SOME_OBSERVATION,
    payload
  };
};

export const setDefaultDelivery = (payload: any) => {
  return {
    type: SET_DEFAULT_DELIVERY,
    payload
  };
};

export const setDeliveryFreightDomain = (payload: any) => {
  return {
    type: SET_SHIPPING_DELIVERY_PROVIDER,
    payload
  };
};

export const setIsBudget = (payload: any) => {
  return {
    type: SET_BUDGET,
    payload
  };
};

export const updateOrderMargin = (payload: any) => {
  return {
    type: UPDATE_ORDER_MARGIN,
    payload
  };
};

export const sendSplitOrderRequest = () => {
  return {
    type: SPLIT_ORDER_VALIDATION_REQUEST
  };
};

export const sendSplitOrderSuccess = (payload: any) => {
  return {
    type: SPLIT_ORDER_VALIDATION_SUCCESS,
    payload
  };
};

export const sendOrder = payload => {
  return {
    type: SEND_ORDER,
    payload
  };
};

export const getProductAlternativesRequest = (productExternalCode: string) => {
  return {
    type: GET_ALTERNATIVE_PRODUCT_REQUEST,
    productExternalCode
  };
};

export const setProductAlternativesSuccess = (payload: any) => {
  return {
    type: GET_ALTERNATIVE_PRODUCT_SUCCESS,
    payload
  };
};

export const setShippingFeeRequest = (shippingFee: number) => {
  return {
    type: SET_SHIPPING_FEE_REQUEST,
    shippingFee
  };
};

export const setVendor = (vendor: string) => {
  return {
    type: SET_VENDOR,
    vendor
  };
};

export const setAssistedSale = (typeSale: string) => {
  return {
    type: SET_ASSISTED_SALE_TYPE,
    typeSale
  };
};
export function applyDiscountToAllItemsRequest(payload) {
  return {
    type: APPLY_DISCOUNT_TO_ALL_ITEMS_REQUEST,
    payload
  };
}

export function applyDiscountToAllItemsSuccess(payload, precision) {
  return {
    type: APPLY_DISCOUNT_TO_ALL_ITEMS_SUCCESS,
    payload,
    precision
  };
}

export const calculateBalanceRequest = (payload?: any) => {
  return {
    type: CALCULATE_BALANCE_REQUEST,
    payload
  };
};

export const updateBalanceSuccess = (payload: { difference: number; finalBalance: number; itemDifference: number }) => {
  return {
    type: UPDATE_BALANCE_SUCCESS,
    payload
  };
};

export const updateOtherExpenses = (payload: number) => {
  return {
    type: UPDATE_ORDER_OTHER_EXPENSES,
    payload
  };
};

export const getRestrictionsRequest = (closeModal = false) => {
  return {
    type: GET_RESTRICTIONS_REQUEST,
    closeModal
  };
};

export const setSubsidiaryProductStockRequest = payload => {
  return {
    type: SET_SUBSIDIARY_PRODUCT_STOCK_REQUEST,
    payload
  };
};

export const setSubsidiaryProductStockSuccess = payload => {
  return {
    type: SET_SUBSIDIARY_PRODUCT_STOCK_SUCCESS,
    payload
  };
};

export const setSubsidiaryStockRestrictions = (payload: SubsidiaryStockRestrictions) => {
  return {
    type: SET_SUBSIDIARY_STOCK_RESTRICTIONS,
    payload
  };
};

export const getSubsidiaryStockRestrictions = ({
  subsidiaryExternalCode,
  subsidiaryStockExternalCode,
  clientState
}: {
  subsidiaryExternalCode: string;
  subsidiaryStockExternalCode: string;
  clientState: string;
}) => {
  return {
    type: SET_SUBSIDIARY_STOCK_RESTRICTIONS_REQUEST,
    payload: { subsidiaryExternalCode, subsidiaryStockExternalCode, clientState }
  };
};
